import {
  Alert,
  Button,
  Container,
  Group,
  Stack,
  Switch,
  Text,
  Title,
  useTheme,
} from "@assetwatch/ui";
import { useState } from "react";
import { useMlSandboxApi } from "../api/mlSandbox";
import config from "../config";

export function HomeScreen() {
  const mlSandbox = useMlSandboxApi();
  const { setTheme, theme } = useTheme();
  const [result, setResult] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  async function handleExploreMl() {
    setIsLoading(true);
    setResult(null);
    setError(null);

    try {
      const data = await mlSandbox.callMlSandbox();
      setResult(JSON.stringify(data, null, 2));
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : String(err));
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Container size="lg">
      <Stack gap={24}>
        <Group justify="between" wrap="wrap">
          <Stack gap={8}>
            <Title size="lg">ML Frontend</Title>
            <Text tone="subtle">
              Frontend workspace generated from the AssetWatch app template.
            </Text>
          </Stack>
          <Group gap={16} wrap="wrap">
            <Switch
              checked={theme === "dark"}
              label="Dark mode"
              onCheckedChange={(checked) =>
                setTheme(checked ? "dark" : "light")
              }
            />
            <Button
              loading={isLoading}
              loadingText="Exploring"
              onClick={() => void handleExploreMl()}
              type="button"
            >
              Explore ML
            </Button>
          </Group>
        </Group>
        <Stack gap={8}>
          <Text tone="subtle">Environment: {config.deployEnvironment}</Text>
          <Text tone="subtle">Endpoint: {mlSandbox.getMlSandboxUrl()}</Text>
        </Stack>
        {result && (
          <pre className="overflow-x-auto rounded-(--radius-sm) bg-surface-inverse-surface p-(--spacing-16) font-mono text-(length:--font-size-body-medium) leading-(--font-line-height-20) text-surface-inverse-on-surface">
            {result}
          </pre>
        )}
        {error && <Alert tone="negative" title={error} />}
      </Stack>
    </Container>
  );
}
